import React, { Component } from "react";
import Layout from "../../hoc/layout/layout";
import "./faq.scss";
import BannerImg from "../../assets/images/faq/aka-07121802-17919@3x.png";
import FaqContent from "./faq.json";

class FaqPage extends Component {
  render() {
    return (
      <>
        {/* <div className="loader-box"></div> */}
        <div className="innerpage-sec faq-section">
          <div className="overlay">
            <img src={BannerImg} alt="" />
          </div>

          <div className="section-header">
            <div className="inner">
              <h1>FAQs</h1>
              <p>
                The information below answers frequently asked questions about
                the 69th Boule Part II/2021 Leadership Seminar.
              </p>
            </div>
          </div>
          {console.log(FaqContent)}

          {FaqContent.content.map((data, key) => (
            <div key={key} className="faq-box">
              <h5>{data.title}</h5>
              <p dangerouslySetInnerHTML={{ __html: data.description }}></p>
              {data.note_text ? (
                <p>
                  <b dangerouslySetInnerHTML={{ __html: data.note_text }}></b>
                </p>
              ) : null}
            </div>
          ))}

          {/* <div className="faq-box">
            <h5>What internet browser should I use?</h5>
            <p>
              The latest versions of Chrome or Firefox guarantee the best
              experience for the Hopin platform. Other browsers may not have the
              latest web technologies necessary for online events to run in a
              web browser.
            </p>
            <p>Both Hopin and vFairs are mobile responsive.</p>
            <p>
              Safari on iOS/iPadOS and Google Chrome on Android are optimal for
              mobile browsers.
            </p>
            <p>
              <b>
                Note: Sometimes, third-party extensions can affect the
                experience blocking some of the Hopin interface elements. That
                is why we also recommend opening the event in Incognito mode
                (command+Shift+N on macOS or Ctrl+Shift+N on Windows) on Chrome
                or Private tab (command+Shift+P for macOS or Ctrl+Shift+P for
                Windows) on Firefox.
              </b>
            </p>
          </div>
          <div className="faq-box">
            <h5>How do I shop for vendors?</h5>
            <p>
              Attendees can access vendors in the Exhibitor Hall on the 69th
              Boule Part II and 2021 Leadership Seminar on the Hopin platform.
            </p>
          </div>
          <div className="faq-box">
            <h5>I am looking for a specific vendor and don’t see them?</h5>
            <p>
              There is a search bar on the Exhibitor Hall lobby page above the
              navigation bar which will take you directly to their booth. Please
              note, all licensed vendors are not participating in the Exhibit
              Hall.
            </p>
          </div>
          <div className="faq-box">
            <h5>Is there a vendor directory?</h5>
            <p>
              Each exhibit hall will have a listing of vendors located in that
              hall. A complete directory is included in the Agenda Book.
            </p>
          </div>
          <div className="faq-box">
            <h5>
              Can I purchase items in the vendor hall through the platform?
            </h5>
            <p>
              All vendors will link to their online store, and attendees can
              make purchases from their website. Please check with the vendor to
              see preferred payment methods.{" "}
            </p>
          </div>
          <div className="faq-box">
            <h5>
              How do I get to the Convention Center from the Exhibitor Hall?
            </h5>
            <p>XYZ</p>
          </div>
          <div className="faq-box">
            <h5>How can I navigate the Auditorium and Convention Center?</h5>
            <p>
              Visit and complete your profile. You can include a short bio,
              customize your avatar/profile picture, add social media profiles
              and websites. This information will be shared if you choose to
              exchange information with a soror.
            </p>
            <p>
              Additionally, you can view the sessions included with your
              registration.
            </p>
          </div>
          <div className="faq-box">
            <h5>Will we see Delegate voting results in real time? </h5>
            <p>
              No. The Supreme Basileus will review and announce the results at a
              later time during the meeting.
            </p>
          </div>
          <div className="faq-box">
            <h5>When do Delegates vote? </h5>
            <p>
              Voting takes place in real time during Plenary Session 1 on
              Wednesday, July 14 and Plenary Session 3 on Thursday, July 15.
            </p>
          </div>
          <div className="faq-box">
            <h5>How do Delegates vote?</h5>
            <p>
              Delegates have special permissions to access delegate ballots.
              They can access the ballot by using the polling feature on the
              Auditorium tab in the side panel.
            </p>
          </div>
          <div className="faq-box">
            <h5>
              Who do we contact if we have issues during the Plenary Session?
            </h5>
            <p>
              For assistance, please click on the Soror Services icon or email
              XYZ.
            </p>
          </div>
          <div className="faq-box">
            <h5>What is the suggested daily attire?</h5>
            <p>Wednesday, July 14 is Scarf Day</p>
            <p>
              Thursday, July 15 will have two suggested attires; wear Pink and
              Green attire during Plenary Session 1 and white during Plenary
              Session 4.
            </p>
            <p>Friday is Pink and or Green Day.</p>
          </div>
          <div className="faq-box">
            <h5>What do I do if I want to speak on the floor? </h5>
            <p>
              On the Auditorium tab on the sided panel, click on the link
              prompting you to speak on the floor. You will be redirected into a
              Zoom meeting. Once you are in the Zoom meeting, your video and
              audio will be live and streamed to session attendees.{" "}
            </p>
            <p>
              As a courtesy, please mute your Hopin session while on the floor
              and in the Zoom meeting to prevent audio feedback.
            </p>
          </div>
          <div className="faq-box">
            <h5>Who can speak during the Plenary Sessions? </h5>
            <p>Everyone can speak on the floor.</p>
          </div>
          <div className="faq-box">
            <h5>Can I customize my settings?</h5>
            <p>
              Yes, click on the three vertical dots. You can elect to enable
              event chat, polls, and Q&A features.
            </p>
            <p>
              To customize your Notifications, click on the bell icon at the top
              right to mute and unmute notifications. All notifications are
              archived here.
            </p>
          </div>
          <div className="faq-box">
            <h5>How do I know what is happening?</h5>
            <p>
              The Reception tab will display the Schedule-At-A-Glance. Navigate
              the schedule by using filters to find sessions. You can also add
              alerts to your calendar when you click the calendar icon.
            </p>
          </div>
          <div className="faq-box">
            <h5>Where are my events happening?</h5>
            <p>
              Use the Reception tab to access the Schedule-At-A-Glance. There
              are several places you can access your personalized agenda.
            </p>
          </div>
          <div className="faq-box">
            <h5>
              Will the sessions be recorded or archived for future access?
            </h5>
            <p>XYZ</p>
          </div>
          <div className="faq-box">
            <h5>How do I attend an event?</h5>
            <p>
              Events will take place in the Auditorium on what we call Stages.
              Larger events such as forums, celebrations, and meetings take
              place in the Auditorium. Workshops and Plenary Sessions can be
              found at AKA University.
            </p>
            <p>
              You can navigate these areas at the designated times or access the
              Reception tab to find an event. The event will have an icon that
              corresponds with its respective location. Access the Auditorium
              tab to find your upcoming event’s stage listing. Click on the
              desired event to access more information or enter at the
              appropriate time. You can also click on the AKA University tab to
              access events.
            </p>
          </div>
          <div className="faq-box">
            <h5>How will I get credit for attending the session?</h5>
            <p>
              Hopin will provide a detailed report of your attendance throughout
              the event. You can expect to see the record of your attendance
              reflected on your Membership Profile XYZ.
            </p>
            <p>
              If you have a dispute about attendance, please contact
              <a href="mailto:XYZ@aka1908.com">XYZ@aka1908.com</a> .
            </p>
          </div>
          <div className="faq-box">
            <h5>How do I engage with sorors?</h5>
            <p>
              There are three ways to engage sorors in the Auditorium and
              Conference Center: networking, chat, and Q&A.
            </p>
            <p>
              If you have a dispute about attendance, please contact
              <a href="mailto:XYZ@aka1908.com">XYZ@aka1908.com</a>.
            </p>
            <p>
              The Networking feature on Hopin allows you to engage intimately
              with sorors. Similar to a one-on-one meeting or a FaceTime call,
              the Networking feature is designed to recreate the
              “coffee-in-the-lobby” conversations or watercooler chats that are
              important at an in-person event. The Networking area automates the
              discovery of new connections. When an attendee participates in
              Networking, they are matched with a random attendee and meet for a
              set time preset by the organizer.
            </p>
            <p>
              Attendees can click the Connect button during a call to exchange
              contact information, and after the event, the newly made contacts
              will appear at the Connections page of their individual profile.
            </p>
            <p>
              On the right side of the screen, click Chat. Comments are limited
              to 500 characters
            </p>
            <p>
              You can also ask a question. On the right side of the screen,
              click Q&A. Click the “Ask a question” button in the bottom right
              corner.
            </p>
            <p>
              You can schedule a meeting by clicking on the paper plane icon.
              You can invite a user to do a video call or schedule a meeting.
            </p>
          </div>
          <div className="faq-box">
            <h5>Who can I network with?</h5>
            <p>
              Networking is arranged at random but can be set to a specific
              ticket type to segment the matchmaking between groups of ticket
              holders.
            </p>
          </div>
          <div className="faq-box">
            <h5>I made so many connections, how do I retrieve my contacts?</h5>
            <p>
              Click on your profile. Click on the Connections tab to retrieve
              your connections and download their contact information.
            </p>
          </div>
          <div className="faq-box">
            <h5>Who do I contact for assistance?</h5>
            <p>
              Click on the Soror Services tab to access assistance and
              troubleshooting. The help desks are staffed during conference
              hours.
            </p>
            <p>
              For assistance with your Membership Profile, contact
              <a href="mailto:XYZ@aka1908.com"> XYZ@aka1908.com</a>.
            </p>
            <p>
              For assistance with the Exhibit Hall, select Info Desk on the
              navigation bar.
            </p>
            <p>
              For assistance with the Auditorium and Convention Center, please
              use the Chat button.
            </p>
          </div> */}
        </div>
      </>
    );
  }
}

export default FaqPage;
